<template>
  <div class="wg-row">
    <wg-modal 
        :width="'400px'" 
        v-if="resultString !== ''" 
        @closeModal="resultString = ''">
      <div slot="body" class="wg-row" style="justify-content:center;">
        <div class="com-anm22-app-text-l" style="text-align:center;">
          {{ resultString }}
        </div>
      </div>
    </wg-modal>
    <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;">
      <div class="com-anm22-app-text-xl">
        {{ $anm22.strLang(lang, 'Listing Template', 'Tabella listino') }}
      </div>
      <button class="small" @click="downloadExcel">
        <img class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getWorldIcon('download')">
        <div class="com-anm22-app-text-l">
          {{ $anm22.strLang(lang, 'Download', 'Scarica') }}
        </div>
      </button>
    </div>
    <div class="vertical-height-div" style="height:15px;"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12">
        <div class="com-anm22-app-text-xl" style="padding:0 2px;">
          {{ $anm22.strLang(lang, 'File content', 'Contenuto file') }}
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
          <input 
              id="file-type-cat"
              type="radio"
              style="display:none;"
              :value="1"
              v-model="fileTypeSelector">
          <label class="radio-label" for="file-type-cat">{{ fileTypeSelector === 1 ? '✔' : '' }}</label>
          <div class="com-anm22-app-text-l" style="margin-left:5px;">{{ $anm22.strLang(lang, 'Categories', 'Categorie') }}</div>
          <div class="horizontal-height-div" style="width:10px;"></div>
          <input 
              id="file-type-prod"
              type="radio"
              style="display:none;"
              :value="2"
              v-model="fileTypeSelector">
          <label class="radio-label" for="file-type-prod">{{ fileTypeSelector === 2 ? '✔' : '' }}</label>
          <div class="com-anm22-app-text-l" style="margin-left:5px;">{{ $anm22.strLang(lang, 'Products', 'Prodotti') }}</div>
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height:15px;"></div>
    <div class="wg-row com-anm22-app-text-xl" style="justify-content:center;background:#ffd740;border-radius:4px;padding:5px;">
      {{ $anm22.strLang(lang, 'Please, check file encoding before uploading', 'Si prega di controllare la codifica del file prima di importare') }}
    </div>
    <div class="vertical-height-div" style="height:15px;"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
        <div class="com-anm22-app-text-xl" style="padding:0 2px;">
          {{ $anm22.strLang(lang, 'Delimiter character', 'Carattere delimitatore') }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
          <select class="com-anm22-app-select" v-model="delimiter">
            <option value=";">{{ $anm22.strLang(lang, 'Semicolon', 'Punto e virgola') }}</option>
            <option value=",">{{ $anm22.strLang(lang, 'Comma', 'Virgola') }}</option>
          </select>
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-6" style="padding: 0 0 0 5px;">
        <div class="com-anm22-app-text-xl" style="padding:0 2px;">
          {{ $anm22.strLang(lang, 'Decimal character', 'Carattere numeri decimali') }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
          <select class="com-anm22-app-select" v-model="number_delimiter">
            <option value=",">{{ $anm22.strLang(lang, 'Comma', 'Virgola') }}</option>
            <option value=".">{{ $anm22.strLang(lang, 'Period', 'Punto') }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height:15px;"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12">
        <div class="com-anm22-app-text-xl" style="padding:0 2px;">
          {{ $anm22.strLang(lang, 'CSV File', 'File CSV') }}
        </div>
        <template v-if="fileError">
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="com-anm22-app-text-m" style="padding:0 2px;color:red;">
            {{ fileError }}
          </div>
        </template>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input type="file" @change="selectFile">
      </div>
    </div>
    <div class="vertical-height-div" style="height:15px;"></div>
    <input 
        type="button" 
        :value="$anm22.strLang(lang, 'Import', 'Importa')" 
        @click="importData">
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {},
  data() {
    return {
      fileTypeSelector: 1,
      delimiter: ';',
      number_delimiter: ',',
      file: null,
      fileError: '',
      resultString: '',
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
  },
  methods: {
    selectFile(e) {
      this.file = e.target.files[0] || e.dataTransfer.files[0];
      this.fileError = '';
    },
    async importData() {
      // Check file extension
      if(this.$anm22.getFileExtension(this.file.name) !== 'csv') {
        this.fileError = this.$anm22.strLang(this.lang, 'Only CSV files are accepted', 'È possibile caricare solo file con estensione .CSV');
      }
      const form = new FormData();
      form.append('delimiter', this.delimiter);
      form.append('number_delimiter', this.number_delimiter);
      form.append('csv', this.file);
      const action = this.fileTypeSelector === 1 ? 'import-categories' : 'import-products';
      try {
        const response = await this.$http.post('inventory/' + action, form);
        if(this.fileTypeSelector === 1) {
          this.$store.dispatch('foodCategories/update', {
            vlf: this.$vlf('foodCategories'), objs: response.data.categories
          });
          this.resultString = this.$anm22.strLang(
            this.lang, 
            'Successfully imported ' + response.data.categories.length + ' categories', 
            'Sono state importate con successo ' + response.data.categories.length + ' categorie'
          )
        } else {
          this.$store.dispatch('foodProducts/update', {
            vlf: this.$vlf('foodProducts'), objs: response.data.products
          });
          this.resultString = this.$anm22.strLang(
            this.lang, 
            'Successfully imported ' + response.data.products.length + ' products', 
            'Sono stati importati con successo ' + response.data.products.length + ' prodotti'
          )
        }
      } catch(e) {
        //TO DO
      }
    },
    async downloadExcel() {
      window.open(process.env.VUE_APP_BACK_DOMAIN + process.env.VUE_APP_BACK_BASE_URL + 'utilities/yourfood_listino.xlsx', '_blank');
    }
  },
  created() {

  }
}
</script>

<style lang="scss" scoped>
.radio-label {
  user-select: none;
  display: block;
  padding-left: 25px;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 50%;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
</style>
